import {TrailWaypoint} from "types/TrailWaypoint";
import {dateTime} from "services/date";

/**
 * Transform the given trailWaypoint by deserializing object properties
 *
 * @internal
 * @param trailWaypoint
 */
export default function deserializeTrailWaypoint(trailWaypoint: any): TrailWaypoint {
    trailWaypoint.created_at = dateTime(trailWaypoint.created_at)
    trailWaypoint.updated_at = dateTime(trailWaypoint.updated_at)

    return trailWaypoint;
}